var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarketplace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Marketplace",
    transform: "translate(-2 -2.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22713",
    "data-name": "Path 22713",
    d: "M3.619,3.251A1.05,1.05,0,0,1,4.625,2.5h15.75a1.05,1.05,0,0,1,1.006.751l1.575,5.263a1.052,1.052,0,0,1,.044.3A4.2,4.2,0,0,1,15.65,11.6a4.194,4.194,0,0,1-6.3,0A4.2,4.2,0,0,1,2,8.816a1.055,1.055,0,0,1,.044-.3L3.619,3.251ZM10.4,8.816a2.1,2.1,0,1,0,4.2,0,1.05,1.05,0,1,1,2.1,0,2.1,2.1,0,0,0,4.2.139l-1.3-4.349H5.406L4.1,8.955a2.1,2.1,0,0,0,4.2-.139,1.05,1.05,0,1,1,2.1,0Z",
    transform: "translate(0)",
    fill: "#444",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22714",
    "data-name": "Path 22714",
    d: "M5.1,19.947V11H3V21a1.051,1.051,0,0,0,1.05,1.053h16.8A1.051,1.051,0,0,0,21.9,21V11H19.8v8.947Z",
    transform: "translate(0.05 0.447)",
    fill: "#444",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketplace);
export default __webpack_public_path__ + "static/media/Marketplace.3b796d7444be69b7b4e7bfd817c9e724.svg";
export { ForwardRef as ReactComponent };